module.exports = __webpack_public_path__ + "static/media/wallet1.d19c11df.png";